import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { HeroImage } from "../../../atoms/HeroImage";
import {
  getRecipeCookTime,
  getRecipeCuisine,
  getStoryHeadline,
  getStoryLabel,
  isExternalStory,
  storyTemplates,
} from "../../../utils/story";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import CookTime from "../../../atoms/CookTime";
import { Label } from "../../../atoms/Label";
import Headline from "../../../atoms/Headline";

import "./story-card.m.css";

const StoryCard = ({ story, showReadTime, showTimeStamp, showCookTime, aspectRatio16to9, sectionSlug }) => {
  const label = getStoryLabel(story);
  const headline = getStoryHeadline(story);

  const isRecipe = story && story["story-template"] === storyTemplates.recipe;
  const cuisine = getRecipeCuisine(story);
  const cookTime = getRecipeCookTime(story);
  let iconSizes = { height: 32, width: 32 };

  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <Link href={href} target={target} styleName="storyCard">
      <HeroImage story={story} aspectRatio={aspectRatio16to9 ? [[16, 9]] : [[4, 3]]} iconSizes={iconSizes} />
      {(label || cuisine) && (
        <div styleName="label-container">
          {label && <Label story={story} />}

          {cuisine && <p styleName="cuisine">{cuisine}</p>}
        </div>
      )}
      {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}
      {cookTime && showCookTime && isRecipe && <CookTime cookTime={cookTime} />}
      {!isRecipe && <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimeStamp} />}
    </Link>
  );
};

StoryCard.propTypes = {
  story: PropTypes.object.isRequired,
  showReadTime: PropTypes.bool,
  showTimestamp: PropTypes.bool,
  showCookTime: PropTypes.bool,
  aspectRatio16to9: PropTypes.bool,
  sectionSlug: PropTypes.string,
};

export default StoryCard;
